const itens = [
  {
    icon: 'ri-volume-down-line',
    titulo: 'Conforto acústico',
    texto: 'Ajuda a reduzir reflexões sonoras e ruídos de passos no ambiente.',
  },
  {
    icon: 'ri-user-heart-line',
    titulo: 'Conforto',
    texto: 'Superfície apropriada para ambientes de trabalho e circulação.',
  },
  {
    icon: 'ri-palette-line',
    titulo: 'Design',
    texto: 'Possibilidade de composição de cores, padrões e paginações.',
  },
  {
    icon: 'ri-layout-grid-line',
    titulo: 'Modularidade',
    texto:
      'Em sistemas modulares, placas individuais podem permitir manutenção localizada conforme produto e instalação.',
  },
  {
    icon: 'ri-building-2-line',
    titulo: 'Ambientes corporativos',
    texto:
      'Solução aplicada em escritórios, salas de reunião, corredores, auditórios, hotelaria e áreas administrativas.',
  },
];

export default function PorQueSection() {
  return (
    <section className="bg-white">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="max-w-2xl mb-14">
          <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
            Por que usar carpete
          </p>
          <h2 className="text-foreground-950 text-[28px] md:text-[40px] font-semibold tracking-tight leading-tight">
            Mais do que acabamento de piso.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {itens.map((item) => (
            <div
              key={item.titulo}
              className="bg-background-50 border border-background-200/60 rounded-2xl p-7 hover:border-primary-300 transition-colors"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="text-foreground-900 text-[17px] font-semibold mb-2.5">
                {item.titulo}
              </h3>
              <p className="text-foreground-500 text-[14px] leading-relaxed">{item.texto}</p>
            </div>
          ))}

          {/* Card nota prudente */}
          <div className="bg-background-100/60 border border-background-200/60 rounded-2xl p-7 flex flex-col justify-center">
            <p className="text-foreground-600 text-[13px] leading-relaxed">
              As características acústicas variam conforme a linha e o fabricante. Não apresentamos
              valores quantitativos sem a documentação técnica do produto especificado.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}